"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Users = function () {
  function Users($q, API) {
    _classCallCheck(this, Users);

    this.$q = $q;
    this.API = API;
  }

  _createClass(Users, [{
    key: "_getOpts",
    value: function _getOpts(applicationName) {
      return {
        params: {
          applicationName: applicationName
        }
      };
    }
  }, {
    key: "getUsers",
    value: function getUsers(applicationName) {
      var deferred = this.$q.defer();
      var url = "v1/users";

      this.API.get(url, this._getOpts(applicationName)).success(function (results) {
        return deferred.resolve(results);
      }).error(function (err) {
        return deferred.reject(err);
      });

      return deferred.promise;
    }
  }, {
    key: "getUserWithGroupInfo",
    value: function getUserWithGroupInfo(userId) {
      var deferred = this.$q.defer();
      var url = "v1/usersWithGroupInfo/" + userId;

      this.API.get(url).success(function (results) {
        deferred.resolve(results);
      }).error(function (err) {
        return deferred.reject(err);
      });

      return deferred.promise;
    }
  }, {
    key: "createUser",
    value: function createUser(user, applicationName) {

      var deferred = this.$q.defer();
      var url = "v1/users";

      var body = JSON.stringify({
        EmailAddress: user.emailAddress,
        FirstName: user.firstName,
        LastName: user.lastName,
        Enabled: true,
        Role: user.role
      });

      this.API.post(url, body, this._getOpts(applicationName)).success(function (results) {
        return deferred.resolve(results);
      }).error(function (err) {
        return deferred.reject(err);
      });

      return deferred.promise;
    }
  }, {
    key: "updateUser",
    value: function updateUser(user, applicationName) {

      var deferred = this.$q.defer();
      var url = "v1/users/" + user.userId;

      var body = JSON.stringify({
        EmailAddress: user.emailAddress,
        FirstName: user.firstName,
        LastName: user.lastName,
        Role: user.role,
        Enabled: user.enabled
      });

      this.API.put(url, body, this._getOpts(applicationName)).success(function (results) {
        return deferred.resolve(results);
      }).error(function (err) {
        return deferred.reject(err);
      });

      return deferred.promise;
    }
  }, {
    key: "removeUser",
    value: function removeUser(userId, applicationName) {
      var deferred = this.$q.defer();
      var url = "v1/users/" + userId;

      this.API.delete(url, this._getOpts(applicationName)).success(function (results) {
        return deferred.resolve(results);
      }).error(function (err) {
        return deferred.reject(err);
      });

      return deferred.promise;
    }
  }, {
    key: "setUserVehicleGroups",
    value: function setUserVehicleGroups(userId, applicationName, vehicleGroupIds) {
      var deferred = this.$q.defer();
      var url = "v1/users/" + userId + "/vehicle-groups";

      var body = JSON.stringify(vehicleGroupIds);

      this.API.put(url, body, this._getOpts(applicationName)).success(function (results) {
        return deferred.resolve(results);
      }).error(function (err) {
        return deferred.reject(err);
      });

      return deferred.promise;
    }
  }, {
    key: "setUserDriverGroups",
    value: function setUserDriverGroups(userId, applicationName, driverGroupIds) {
      var deferred = this.$q.defer();
      var url = "v1/users/" + userId + "/driver-groups";
      var body = JSON.stringify(driverGroupIds);

      this.API.put(url, body, this._getOpts(applicationName)).success(function (results) {
        return deferred.resolve(results);
      }).error(function (err) {
        return deferred.reject(err);
      });

      return deferred.promise;
    }
  }]);

  return Users;
}();

exports.default = Users;


Users.$inject = ["$q", "FleetPortalAPI"];


// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-fleetlink/fleetlink.user.js